import React, { useContext, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

const PaymentResult = () => {
  const [params] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = params.get("state") === "success";

  useEffect(() => {
    if (isSuccess) clearCart();
  }, [clearCart, isSuccess]);

  return (
    <div className={`successDiv ${isSuccess ? "payment-success" : "payment-cancel"}`}>
      <div className="success-container">
        <div className="modal-content">
          <div className="checkmark-circle">
            <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
          </div>
          <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
          <p>
            {isSuccess
              ? "Thank you. Your payment was received and your order is being prepared."
              : "No payment was completed. Your cart is still available if you would like to try again."}
          </p>
          <Link className="payment-result-link" to={isSuccess ? "/shop" : "/checkout"}>
            {isSuccess ? "Continue shopping" : "Return to checkout"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentResult;
